import React, {useEffect, useState} from 'react';
import {MuiPickersUtilsProvider, KeyboardDatePicker} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import TextField from '@material-ui/core/TextField';
import moment from 'moment';

const GuiTextDateField = ({
  name,
  onChange,
  value,
  errors,
  error,
  textFieldProps,
  ...otherProps
}) => {
  const [daysToAdd, setDaysToAdd] = useState('');
  const [selectedDate, setSelectedDate] = useState(null);
  useEffect(() => {
    setSelectedDate(value ? moment(value).format('MM-DD-YYYY') : null);
  }, [value]);
  useEffect(() => {
    let selectedDateObj;

    if (selectedDate instanceof Date && !isNaN(selectedDate)) {
      selectedDateObj = selectedDate;
    } else if (selectedDate) {
      selectedDateObj = new Date(selectedDate);
    } else {
      setDaysToAdd('');
      return;
    }
    if (selectedDateObj instanceof Date && !isNaN(selectedDateObj)) {
      const today = new Date();
      const timeDifference = selectedDateObj.getTime() - today.getTime();
      const daysDifference = Math.ceil(timeDifference / (1000 * 3600 * 24));
      setDaysToAdd(daysDifference.toString());
    }
  }, [selectedDate]);

  const handleDaysChange = (event) => {
    const newValue = event.target.value;
    if (newValue === '') {
      onChange(null);
    } else {
      if (/^[+-]?\d*$/.test(newValue)) {
        setDaysToAdd(newValue);
      }

      const regex = /^([-+]?\d+)$/;
      const match = newValue.match(regex);

      if (match) {
        const daysDifference = parseInt(match[1], 10);
        const currentDate = new Date();
        const updatedDate = new Date(currentDate);
        updatedDate.setDate(currentDate.getDate() + daysDifference);
        onChange(updatedDate);
      }
    }
  };

  return (
    <div className={error ? 'custom-date-picker d-flex' : ' d-flex'}>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <div className="dynamic-date-number-field">
          <TextField
            type="text"
            value={daysToAdd}
            onChange={handleDaysChange}
            disabled={Boolean(otherProps?.disabled)}
            margin="dense"
            variant="outlined"
            {...textFieldProps}
          />
        </div>
        <KeyboardDatePicker
          name={name}
          format="MM/dd/yyyy"
          value={value}
          onChange={onChange}
          {...otherProps}
        />
      </MuiPickersUtilsProvider>
    </div>
  );
};

export default GuiTextDateField;
